const h = ":host{display:block;font-family:var(--sl-font-family-base)}.sl-pagination{display:flex;align-items:center;justify-content:center;gap:var(--sl-spacing-1)}.sl-pagination__container{display:flex;align-items:center;gap:var(--sl-spacing-1)}.sl-pagination__prev,.sl-pagination__next,.sl-pagination__page{display:inline-flex;align-items:center;justify-content:center;min-width:2.25rem;height:2.25rem;padding:0 var(--sl-spacing-2);border:var(--sl-border-1) solid var(--sl-border-color);border-radius:var(--sl-radius-md);background-color:var(--sl-pagination-bg,var(--sl-card-bg));color:var(--sl-pagination-color,var(--sl-foreground));font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);cursor:pointer;transition:background-color var(--sl-transition-fast) var(--sl-transition-timing-out),border-color var(--sl-transition-fast) var(--sl-transition-timing-out),color var(--sl-transition-fast) var(--sl-transition-timing-out);user-select:none}.sl-pagination__prev:hover,.sl-pagination__next:hover,.sl-pagination__page:hover:not(:disabled){background-color:var(--sl-pagination-hover-bg,var(--sl-gray-100));border-color:var(--sl-gray-300)}.sl-pagination__page--active{background-color:var(--sl-pagination-active-bg,hsl(var(--sl-hsl-primary)));color:var(--sl-pagination-active-color,var(--sl-primary-foreground));border-color:var(--sl-pagination-active-bg,hsl(var(--sl-hsl-primary)));cursor:default}.sl-pagination__page--active:hover{background-color:var(--sl-pagination-active-bg,hsl(var(--sl-hsl-primary)));border-color:var(--sl-pagination-active-bg,hsl(var(--sl-hsl-primary)))}.sl-pagination__prev:disabled,.sl-pagination__next:disabled{opacity:0.4;cursor:not-allowed;background-color:var(--sl-gray-50)}.sl-pagination__ellipsis{display:inline-flex;align-items:center;justify-content:center;padding:0 var(--sl-spacing-1);color:var(--sl-gray-400);font-size:var(--sl-font-size-sm);user-select:none}.sl-pagination--sm .sl-pagination__prev,.sl-pagination--sm .sl-pagination__next,.sl-pagination--sm .sl-pagination__page{min-width:1.75rem;height:1.75rem;font-size:var(--sl-font-size-xs);padding:0 var(--sl-spacing-1)}.sl-pagination--lg .sl-pagination__prev,.sl-pagination--lg .sl-pagination__next,.sl-pagination--lg .sl-pagination__page{min-width:2.75rem;height:2.75rem;font-size:var(--sl-font-size-base);padding:0 var(--sl-spacing-3)}";
class u extends HTMLElement {
  static get observedAttributes() {
    return ["total", "current", "size", "show-ellipsis", "sibling-count"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._container = document.createElement("div"), this._render();
  }
  connectedCallback() {
    this._updatePagination();
  }
  attributeChangedCallback(t, i, e) {
    i !== e && this._updatePagination();
  }
  get total() {
    return parseInt(this.getAttribute("total") || "1", 10) || 1;
  }
  set total(t) {
    this.setAttribute("total", String(t));
  }
  get current() {
    return parseInt(this.getAttribute("current") || "1", 10) || 1;
  }
  set current(t) {
    this.setAttribute("current", String(t));
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  get showEllipsis() {
    return this.hasAttribute("show-ellipsis");
  }
  set showEllipsis(t) {
    t ? this.setAttribute("show-ellipsis", "") : this.removeAttribute("show-ellipsis");
  }
  get siblingCount() {
    return parseInt(this.getAttribute("sibling-count") || "1", 10) || 1;
  }
  set siblingCount(t) {
    this.setAttribute("sibling-count", String(t));
  }
  _goToPage(t) {
    t < 1 || t > this.total || (this.current = t, this.dispatchEvent(new CustomEvent("sl-page-change", {
      bubbles: !0,
      composed: !0,
      detail: { page: t }
    })));
  }
  _render() {
    const i = ["sl-pagination", `sl-pagination--${this.size}`];
    this._shadow.innerHTML = `
      <style>${h}</style>
      <nav class="${i.join(" ")}" role="navigation" aria-label="Pagination">
        <div class="sl-pagination__container"></div>
      </nav>
    `, this._container = this._shadow.querySelector(".sl-pagination__container");
  }
  _updatePagination() {
    const t = this.total, i = this.current, e = this.siblingCount, o = this.showEllipsis;
    this._container.innerHTML = "";
    const s = this._createButton(
      i > 1 ? i - 1 : 1,
      "‹",
      i > 1,
      "sl-pagination__prev"
    );
    this._container.appendChild(s), this._generatePageNumbers(i, t, e, o).forEach((n) => {
      if (typeof n == "string") {
        const a = document.createElement("span");
        a.className = "sl-pagination__ellipsis", a.setAttribute("aria-hidden", "true"), a.textContent = "...", this._container.appendChild(a);
      } else {
        const a = this._createButton(
          n,
          String(n),
          !0,
          n === i ? "sl-pagination__page sl-pagination__page--active" : "sl-pagination__page"
        );
        n === i && a.setAttribute("aria-current", "page"), this._container.appendChild(a);
      }
    });
    const g = this._createButton(
      i < t ? i + 1 : t,
      "›",
      i < t,
      "sl-pagination__next"
    );
    this._container.appendChild(g);
  }
  _createButton(t, i, e, o) {
    const s = document.createElement("button");
    return s.className = o, s.setAttribute("aria-label", i === "‹" ? "Previous page" : i === "›" ? "Next page" : `Page ${t}`), s.textContent = i, e || (s.disabled = !0, s.setAttribute("aria-disabled", "true")), e && s.addEventListener("click", () => this._goToPage(t)), s;
  }
  _generatePageNumbers(t, i, e, o) {
    const s = [], l = e * 2 + 3;
    if ((i > l + 1 ? 2 : 0) === 0)
      for (let n = 1; n <= i; n++)
        s.push(n);
    else {
      const n = Math.max(2, t - e), a = Math.min(i - 1, t + e), c = n > 2, p = a < i - 2;
      if (o) {
        s.push(1), c && s.push("...");
        for (let r = n; r <= a; r++)
          s.push(r);
        p && s.push("..."), s.push(i);
      } else
        for (let r = 1; r <= i; r++)
          s.push(r);
    }
    return s;
  }
}
typeof customElements < "u" && !customElements.get("sl-pagination") && customElements.define("sl-pagination", u);
export {
  u as SlPaginationElement
};
//# sourceMappingURL=sl-pagination.js.map
